import React, { useMemo, useState } from "react";
import { Modal, Input, List, Empty, Typography } from "antd";

const { Text } = Typography;

export default function ItemPickerModal({
  open,
  title,
  loading,
  items,
  onSelect,
  onCancel,
}) {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query) return items;
    const q = query.toLowerCase();
    return items.filter((item) => item.name.toLowerCase().includes(q));
  }, [items, query]);

  return (
    <Modal
      title={title}
      visible={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      afterClose={() => setQuery("")}
    >
      <Input.Search
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ marginBottom: "1rem" }}
        autoFocus
      />
      <List
        loading={loading}
        dataSource={filtered}
        locale={{ emptyText: <Empty description="No items found" /> }}
        style={{ maxHeight: 360, overflowY: "auto" }}
        renderItem={(item) => (
          <List.Item
            style={{ cursor: "pointer" }}
            onClick={() => onSelect(item)}
          >
            <List.Item.Meta
              title={item.name}
              description={
                item.sublabel ? (
                  <Text type="secondary">{item.sublabel}</Text>
                ) : null
              }
            />
          </List.Item>
        )}
      />
    </Modal>
  );
}
